import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import type {
  IPlatformPeopleAccountsDashboard,
  PlatformDashboardGrowthPeriod,
} from '@brushfire/types'

export async function fetchPeopleAccountsDashboard(
  growthPeriod: PlatformDashboardGrowthPeriod,
): Promise<IPlatformPeopleAccountsDashboard> {
  const { data } = await apiClient.get<ApiResponse<IPlatformPeopleAccountsDashboard>>(
    '/api/v1/platform/dashboard/people-accounts',
    { params: { growthPeriod } },
  )
  if (!data.data) {
    throw new Error('People & Accounts dashboard response missing data')
  }
  return data.data
}
